export const STATUS_OPTIONS = {
  buyer: 'Buyer',
  closed: 'Closed',
  dead: 'Dead',
  Duplicate: 'Duplicate',
  followup: 'Follow-up',
  listing: 'Listing',
  newlead: 'New',
  outofarea: 'Out of area',
  pending: 'Pending',
};
export const AVAILABLE_STATUS_OPTIONS = {
  buying: {
    newlead: [
      'newlead',
      'followup',
      'buyer',
      'pending',
      'closed',
      'Duplicate',
      'outofarea',
      'dead',
    ],
    followup: [
      'followup',
      'buyer',
      'pending',
      'closed',
      'Duplicate',
      'outofarea',
      'dead',
    ],
    buyer: ['followup', 'buyer', 'pending', 'closed', 'dead'],
    pending: ['buyer', 'pending', 'closed', 'dead'],
    closed: ['closed'],
    dead: ['followup', 'pending', 'dead'],
    outofarea: ['followup', 'outofarea'],
    Duplicate: ['followup', 'Duplicate'],
  },
  selling: {
    newlead: [
      'newlead',
      'followup',
      'listing',
      'pending',
      'closed',
      'Duplicate',
      'outofarea',
      'dead',
    ],
    followup: [
      'followup',
      'listing',
      'pending',
      'closed',
      'Duplicate',
      'outofarea',
      'dead',
    ],
    listing: ['followup', 'listing', 'pending', 'closed', 'dead'],
    pending: ['listing', 'pending', 'closed', 'dead'],
    closed: ['closed'],
    dead: ['followup', 'listing', 'pending', 'dead'],
    outofarea: ['followup', 'outofarea'],
    Duplicate: ['followup', 'Duplicate'],
  },
};
export const AVAILABLE_STATUS_FORM_FIELDS = {
  buying: {
    newlead: ['next_follow_up_date', 'note'],
    followup: ['next_follow_up_date', 'note'],
    buyer: ['note'],
    pending: [
      'street_address',
      'short_sale',
      'referral_fee',
      'referral_rate',
      'transaction_value',
      'closing_date_container',
      'projected_closing_date',
      'commission_amount',
      'commission_rate',
      'note',
    ],
    closed: [
      'street_address',
      'short_sale',
      'referral_fee',
      'referral_rate',
      'transaction_value',
      'closing_date_container',
      'closing_date',
      'hud_attachment',
      'commission_amount',
      'commission_rate',
      'note',
    ],
    Duplicate: ['note'],
    outofarea: ['note'],
    dead: ['note'],
  },
  selling: {
    newlead: ['next_follow_up_date', 'note'],
    followup: ['next_follow_up_date', 'note'],
    listing: [
      'street_address',
      'short_sale',
      'transaction_value',
      'listing_date_container',
      'date_listed',
      'listing_expiration_date',
      'commission_amount',
      'commission_rate',
      'note',
    ],
    pending: [
      'street_address',
      'short_sale',
      'referral_fee',
      'referral_rate',
      'transaction_value',
      'closing_date_container',
      'projected_closing_date',
      'commission_amount',
      'commission_rate',
      'note',
    ],
    closed: [
      'street_address',
      'short_sale',
      'referral_fee',
      'referral_rate',
      'transaction_value',
      'closing_date_container',
      'closing_date',
      'hud_attachment',
      'commission_amount',
      'commission_rate',
      'note',
    ],
    Duplicate: ['note'],
    outofarea: ['note'],
    dead: ['note'],
  },
};
export const PAID_STATUS_DISABLED_OPTIONS = [
  'transaction_value',
  'commission_amount',
  'commission_rate',
];
export const ALL_FIELDS = {
  buying: [
    'next_follow_up_date',
    'street_address',
    'short_sale',
    'referral_fee',
    'referral_rate',
    'transaction_value',
    'closing_date',
    'commission_amount',
    'commission_rate',
    'note',
  ],
  selling: [
    'next_follow_up_date',
    'street_address',
    'short_sale',
    'referral_fee',
    'referral_rate',
    'transaction_value',
    'date_listed',
    'listing_expiration_date',
    'closing_date',
    'commission_amount',
    'commission_rate',
    'note',
  ],
};
